function LoyaltyModalTextTitle({ children }) {
  return <div className="loyalty-modal-text-title">{children}</div>;
}

export default LoyaltyModalTextTitle;
